import { parse } from 'url';
import { Auth } from 'aws-amplify';
import Logger from '../../../utility/services/Logger';
import { showError } from '../alerts/alerts';

export const urlSafeDecode = (hex) =>
  hex
    .match(/.{2}/g)
    .map((char) => String.fromCharCode(parseInt(char, 16)))
    .join('');

export const validateState = (urlParams) => {
  if (!urlParams) {
    return null;
  }

  const savedState = localStorage.getItem('state');
  localStorage.removeItem('state');
  const { state: returnedState } = urlParams;

  if (savedState && savedState !== returnedState) {
    const err = new Error('Invalid state in OAuth flow');
    Logger.LogError(err, { savedState, returnedState, urlParams });
    throw err;
  }
  return returnedState;
};

export const getUrlParamObj = (href) =>
  href
    ? {
        ...(parse(href).hash || '#')
          .substr(1)
          .split('&')
          .map((entry) => entry.split('='))
          .reduce((acc, [k, v]) => {
            acc[k] = v;
            return acc;
          }, {}),
        ...(parse(href).query || '')
          .split('&')
          .map((entry) => entry.split('='))
          .reduce((acc, [k, v]) => {
            acc[k] = v;
            return acc;
          }, {}),
      }
    : {};

export const generateState = (length) => {
  let result = '';
  let i = length;
  const chars =
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  for (; i > 0; i -= 1)
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  return result;
};

export const urlSafeEncode = (str) =>
  str
    .split('')
    .map((char) => char.charCodeAt(0).toString(16).padStart(2, '0'))
    .join('');

const getCustomState = (urlParams) => {
  const isCustomStateIncluded = /-/.test(urlParams.state);
  if (isCustomStateIncluded) {
    const customState = urlParams.state.split('-').splice(1).join('-');
    return JSON.parse(decodeURIComponent(urlSafeDecode(customState)));
  }
  return null;
};

export const handleSSOResponse = (href, currentLocation) => {
  const urlParams = getUrlParamObj(currentLocation);
  try {
    if (!validateState(urlParams)) {
      throw new Error('Invalid state in OAuth flow');
    }
    return getCustomState(urlParams);
  } catch (err) {
    Auth.signOut();
    Logger.LogError(err, {
      err,
      locObj: currentLocation,
      urlParams,
      locref: href,
    });
    showError('Auth Error.!', false);
    throw err;
  }
};
